import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ruhul from "../../assets/imgs/instructor-img-10.png";
import styles from "./FamilyDevelopment.module.css";
import Image from "next/image";

function FamilyDevelopment(props) {
  return (
    <>
    <div className="Section">

      <Container maxWidth="lg">
        <div className={styles.FamilyDevelopment} style={{marginTop:"60px"}}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <h1>MUNA Family Development</h1>
              <p>
              MUNA Family Development Dept. offers courses and seminars on marriage, parenting, and healthy living from Islamic and research-based perspectives.
              </p>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <a className={styles.FamilyDevelopmentCard}>
                <div className={styles.FamilyDevelopmentCardImg}>
                  <img src="https://cdn.mytakbir.com/static-assets/images/Imam-Ajmal-Masroor.jpg" />
                </div>
                <div className={styles.FamilyDevelopmentCardInfo}>
                  <h2>
                   Imam Ajmal Masroor
                  </h2>
                  <h3>
                  Co-Founder, Barefoot Institute
                  </h3>
                </div>
              </a>
            </Grid>
  
          </Grid>
        </div>
      </Container>




      
    </div>

    </>
  );
}

export default FamilyDevelopment;
